import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_SITE_URL = 'https://www.subtitletsunami.com';
const DEFAULT_IMAGE = `${DEFAULT_SITE_URL}/og-image.png`;

const SEO = ({
  title = 'SubtitleTsunami - AI English to Spanish Subtitle Generator',
  description = 'SubtitleTsunami is an AI-powered English to Spanish subtitle generator for videos. Upload a video, generate Spanish subtitles, and download your subtitled video.',
  canonical = `${DEFAULT_SITE_URL}/`,
  image = DEFAULT_IMAGE,
  type = 'website',
  jsonLd = null,
}) => {
  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow" />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="SubtitleTsunami" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="SubtitleTsunami AI subtitle generator logo" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="SubtitleTsunami AI subtitle generator logo" />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;